import { reloadAuthorized } from './Authorized';

// use localStorage to store the authority info, which might be sent from server in actual project.
export function getAuthority(str?: string): string | string[] {
  const authorityString =
    typeof str === 'undefined' && sessionStorage ? sessionStorage.getItem('packing-tools-authority') : str;
  // authorityString could be admin, "admin", ["admin"]
  let authority;
  try {
    if (authorityString) {
      authority = JSON.parse(authorityString);
    }
  } catch (e) {
    authority = authorityString;
  }
  if (typeof authority === 'string') {
    return [authority];
  }
  return authority;
}



export const getMenu = (authority: any[]) => {
  const map: any = {};

  const arr: any[] = authority.filter((el) => {
    el.path = el.urlPath || el.path
    return el.type != 2 && el.path
  });
  arr.forEach((el: any) => {
    map[el.id] = el;
  })

  arr.forEach((item: any) => {
    if (map[item.pid]) {
      if (!map[item.pid].children) {
        map[item.pid].children = [];
      }
      // if (item.isShow) {
      map[item.pid].children.push(item);
      // }
      map[item.pid].children.sort((a: any, b: any) => b.sort - a.sort);

    }
  })
  const target = Object.values(map)
    .filter((el: any) => (el.isShow && !map[el.pid]))
    .sort((a: any, b: any) => b.sort - a.sort)
    .map((el: any) => ({ ...el, isParent: true }));

  return target
}

export const getButtons = (authority: any[]) => {
  let arrB: any = [];
  const arr: any[] = authority.filter((el) => {
    if (el.type == 2) {
      arrB.push(el.urlPath)
    }
  });
  return arrB
}

export const getPersonalAuthority = (menu: any[]) => {
  let temp: any[] = [];
  menu.forEach(((el) => {

    // if (el.isShow) {
    temp.push(el.path);
    if (el.children) {
      temp = [...temp, ...getPersonalAuthority(el.children)]
    }
    // }

  }))
  return temp
}

export function setAuthority(authority: any[]): void {
  sessionStorage.setItem('packing-tools-authority', JSON.stringify(authority));
  // auto reload
  reloadAuthorized();
}
